import { getRESTParams, WP_API_URL } from '.'

const BASE_PATH = `${WP_API_URL}/pages`

/* =============================================
 * Private helpers
 * ============================================= */

/**
 * Common Resource page request pattern.
 * @param {String} url The REST URL to query.
 * @param {Object} params Parameter object to merge with common params, if necessary.
 * See getRESTParams method for more info.
 */
const _resourceRESTGET = async (url, params) => {
  const response = await fetch(url, getRESTParams(params))
    .then(result => result.json())
    .catch(error => {
      console.error({ error })

      return error
    })

  return response
}

/* =============================================
 * Public methods
 * ============================================= */

/**
 * Retrieves a Resource Page Object given its ID.
 * @param {Number} resourceId The Resource ID to lookup.
 */
const getResourcePageById = async resourceId => {
  // Return early if we received an invalid or empty ID
  if (!resourceId) return

  const url = `${BASE_PATH}/${resourceId}`
  return await _resourceRESTGET(url)
}

export { getResourcePageById }
